import { useContext } from 'react';

import { useParams } from 'react-router-dom';

import { apiGetAvailabilities } from '../../../../constants';
import { CoreContext } from '../../../../context/CoreContext';
import useIsTablet from '../../../../hooks/useIsTablet';
import useReadAvailabilityFilters from '../../../../hooks/useReadAvailabilityFilters';
import FilteredList from '../../../generic/FilteredList';
import AvailabilitiesList from './AvailabilitiesList';
import { AVAILABILITIES_FILTERS } from './AvailabilitiesListFilters';
import AvailabilitiesListMultiSelect from './AvailabilitiesListMultiSelect';

const AVAILABILITIES_FILTERS_PER_SCROLL = 20;
const AVAILABILITIES_FILTERS_PER_LINE_TABLET_MODE = 2;

const AvailabilitiesFilteredList = () => {
  const isTablet = useIsTablet();
  const { coreData } = useContext(CoreContext);
  const { multiple_selection: isMultipleSelection } = coreData.booking_engine;

  const { productId } = useParams();

  // This goes outside hooks because we need it before anything else
  // It also doesnt go in AVAILABILITIES_FILTERS because it wouldnt reload the date
  // So if the user is browsing at 23h50 then the filter will be wrong
  AVAILABILITIES_FILTERS.DATE.default = new Date();

  const filtersToDisplay = useReadAvailabilityFilters();

  return (
    <FilteredList
      listType={isMultipleSelection ? AvailabilitiesListMultiSelect : AvailabilitiesList}
      endpoint={apiGetAvailabilities(productId)}
      propertyToReturn="availabilities"
      itemsPerScroll={AVAILABILITIES_FILTERS_PER_SCROLL}
      filtersToDisplay={filtersToDisplay}
      filtersPerLine={isTablet ? AVAILABILITIES_FILTERS_PER_LINE_TABLET_MODE : undefined} // undef = use default value
      skeletonHeight="77px"
      showFiltersMobile
    />
  );
};

export default AvailabilitiesFilteredList;
